module.exports = __webpack_public_path__ + "img/drawing1.9a4179f6.png";